import { Component, OnInit, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { LogsData } from 'src/app/model/LogsData';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';

export interface ActivityHistoryData {
  activity: string;
  time: string;
  calories: string;
  date: string;
}

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  displayedColumns: string[] = ['activity', 'time', 'calories', 'date'];
  dataSource = new MatTableDataSource<ActivityHistoryData>();
  data: LogsData[];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    var ACTIVITY_DATA : ActivityHistoryData[] = [];

    this._bkoffService.getActivityHistory().then((res) => {
      this.data = res;
      console.log(res);
      this.data.forEach(element => {
        if (element.activityCalories != null) {
          ACTIVITY_DATA.push({activity: element.activity, time: element.time, calories: element.activityCalories.toString(), date: element.activityDate});
        } else {
          ACTIVITY_DATA.push({activity: element.activity, time: element.time, calories: "N/A", date: element.activityDate});
        }
      });  
      this.dataSource = new MatTableDataSource<ActivityHistoryData>(ACTIVITY_DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }
}


